module.exports = __webpack_public_path__ + "static/media/Ceris.8f6b1fef.png";